import request from '@/utils/request'

// 通用API
let AfuncApi = {
  /*通用API调用*/
  call(data) {
    // 如果没有指定model，设置默认值
    if (!data.model) {
      data.model = 'ma_employee';
    }
    return request._post('/shop/Afunc/handle', data);
  },
  
  /*通用快捷方法*/
  index(data) {
    return this.call({
      action: 'index',
      ...data
    });
  },
  
  add(data) {
    return this.call({
      action: 'add',
      ...data
    });
  },
  
  edit(data) {
    return this.call({
      action: 'edit',
      ...data
    });
  },
  
  del(data) {
    return this.call({
      action: 'del',
      ...data
    });
  },
  
  detail(data) {
    return this.call({
      action: 'detail',
      ...data
    });
  },
  
  deleteAll(data) {
    return this.call({
      action: 'deleteAll',
      ...data
    });
  },
  
  changeStatus(data) {
    return this.call({
      action: 'changeStatus',
      ...data
    });
  },
  
  resetPassword(data) {
    return this.call({
      action: 'resetPassword',
      ...data
    });
  },
  
  export(data) {
    return this.call({
      action: 'export',
      ...data
    });
  },
  
  import(data) {
    const formData = new FormData();
    // 前端需要传递model和action
    formData.append('model', data.model || 'ma_employee');
    formData.append('action', 'import');
    
    if (data.file) {
      formData.append('file', data.file);
    }
    
    // 添加其他参数
    for (let key in data) {
      if (key !== 'file' && key !== 'model') {
        formData.append(key, data[key]);
      }
    }
    
    return request._post('/shop/Afunc/handle', formData);
  },
  
  batchAdd(data) {
    return this.call({
      action: 'batchAdd',
      ...data
    });
  },
  
  /*创建特定模块的快捷API（兼容旧版）*/
  createModuleApi(moduleName) {
    const api = {};
    const methods = ['index', 'add', 'edit', 'del', 'detail', 'deleteAll', 'changeStatus', 'resetPassword', 'export', 'batchAdd'];
    
    methods.forEach(method => {
      api[method] = (data) => {
        return this.call({
          model: moduleName,
          action: method,
          ...data
        });
      };
    });
    
    // 特殊方法
    api.import = (data) => {
      return this.import({
        model: moduleName,
        ...data
      });
    };
    
    api.call = this.call;
    
    return api;
  }
}

export default AfuncApi;


// WEBPACK FOOTER //
// ./src/api/afunc.js